<template>
  <v-card min-height="80vh">
    <v-card-title class="primary white--text">
      <span class="headline">
        {{ title }}
      </span>
      <v-spacer/>
      <BaseDialogActions hideRefresh/>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-chip>
              {{ dateRangeAsString }}
            </v-chip>
          </v-col>
          <v-col cols="12" class="pl-4 pr-4">
            <v-row align="center">
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  clearable
                  color="primary"
                />
              </v-col>
              <v-col cols="auto">
                <ColumnAdjuster
                  :propColumnSet.sync="columnSet"
                  @new-columns-selected="newColumnsSelected"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <ProductSummaryByTract
              :tractSummaries="tracts"
              :entity="entity"
              :search="search"
              :columnSet="columnSet"
              :dateRange="dateRange"
              :chosenCategory="chosenCategory"
              :speciesMode="speciesMode"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import TractHeaders from '@/headers/Tract.js'
import { companyOffsetToLocalDate } from '@/utils/DateFormatter.js'
import { uniqueDialogId } from '@/utils/componentHelpers'
export default {
  name: 'SupplierTractsDetail',

  components: {
    ProductSummaryByTract: () => import('@/components/tract/tract-analysis/ProductSummaryByTract.vue'),
    ColumnAdjuster: () => import('@/components/core/ColumnAdjuster.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    supplier: {
      type: String,
      required: true
    },
    tracts: {
      type: Array,
      required: true
    },
    dateRange: {
      type: Object,
      required: false,
      default: undefined
    },
    entity: {
      type: Object,
      required: false,
      default: undefined
    },
    chosenCategory: {
      type: Number,
      required: true
    },
    speciesMode: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    dialogId: uniqueDialogId('supplier-tract-details'),
    selectedEntity: undefined,
    focusedSupplierSummary: null,
    filteredSupplierSummaries: undefined,
    columnSet: undefined,
    search: ''
  }),

  created () {
    this.columnSet = this.speciesMode ? TractHeaders.tractSummaryHeadersBySpecies() : TractHeaders.tractSummaryHeaders()
  },

  computed: {
    title () {
      return this.$t('entityTractsForSupplier', { entity: this.entity.name, supplier: this.supplier })
    },

    dateRangeAsString () {
      return `${companyOffsetToLocalDate(this.dateRange.sinceTime)} \u2014 ${companyOffsetToLocalDate(this.dateRange.untilTime, 'L')}`
    }
  },

  methods: {
    newColumnsSelected (columnSet) {
      this.columnSet = columnSet
    }
  }
}
</script>
